import { Routes } from '@angular/router';

import { LoginComponent } from './auth/login/login.component';
import { ZendeskSSOComponent } from './auth/login-zendesk-sso/login-zendesk-sso.component';
import { LoginssoComponent } from './auth/loginsso/loginsso.component';
import { AppGuard } from './guards/app.guard';
import { DesktopResolverService } from './guards/desktop-resolver.service';
import { TfaComponent } from './auth/tfa/tfa.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { SetPasswordComponent } from './auth/set-password/set-password.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { MobileComponent } from '@app/mobile/mobile.component';
import { MobileGuard } from '@app/guards/mobile.guard';
import { LoginGuard } from '@app/auth/login.guard';
import { LocalesResolver } from './guards/locales.resolver';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard, MobileGuard],
  },
  {
    path: 'zendesk-sso',
    component: ZendeskSSOComponent,
    canActivate: [AppGuard, MobileGuard],
  },
  {
    path: 'loginsso',
    component: LoginssoComponent,
    canActivate: [LoginGuard, MobileGuard],
  },
  {
    path: 'tfa',
    component: TfaComponent,
    canActivate: [MobileGuard],
  },
  {
    path: 'forgot-password',
    component: ResetPasswordComponent,
    canActivate: [MobileGuard],
  },
  {
    path: 'set-password/:token',
    component: SetPasswordComponent,
    canActivate: [MobileGuard],
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [AppGuard, MobileGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./desktop/desktop.module').then((m) => m.DesktopModule),
    canActivate: [AppGuard, MobileGuard],
    resolve: {
      locales: LocalesResolver
    }
  },
  {
    path: 'mobile',
    component: MobileComponent,
  },
  { path: '**', redirectTo: '/report/' },
];
